export const FEW_MINUTES = 'FEW_MINUTES';
export const FEW_HOURS = 'FEW_HOURS';
export const WITHIN_DAY = 'WITHIN_DAY';